import { GeneralAdmissionSelling } from 'components/selling/generalSelling'
import { SeatBasedSelling } from 'components/selling/seatBasedSelling'
import { useSelectedSeats } from 'hooks/user/useSelling'
import { useTotalPrice } from 'hooks/user/useSelling/useTotalPrice'
import React from 'react'
import { EventDetails, SeatSellingModes } from 'types/Event'

interface Props {
    currentEvent: EventDetails
    actionLabel: string
    actionHandler: (selectedSeats: string[]) => void
    complimentaryButton?: boolean
    isComplimentary?: boolean
    setIsComplimentary?: React.Dispatch<React.SetStateAction<boolean>>
}

export const SeatSelector: React.FC<Props> = ({
    currentEvent,
    actionLabel,
    actionHandler,
    complimentaryButton = false,
    isComplimentary,
    setIsComplimentary,
}) => {
    const eventId = currentEvent.event_id
    const sellingMode = currentEvent.seat_selling_mode

    const { selectedSeats, changeSelectedSeats } = useSelectedSeats(eventId)
    const totalPrice = useTotalPrice(selectedSeats, currentEvent.tickets, isComplimentary)

    return (
        <>
            {sellingMode === SeatSellingModes.SeatBased ? (
                <SeatBasedSelling
                    currentEvent={currentEvent}
                    selectedSeats={selectedSeats}
                    changeSelectedSeats={changeSelectedSeats}
                    totalPrice={totalPrice}
                    actionLabel={actionLabel}
                    actionHandler={actionHandler}
                    complimentaryButton={complimentaryButton}
                    isComplimentary={isComplimentary}
                    setIsComplimentary={setIsComplimentary}
                />
            ) : (
                <GeneralAdmissionSelling
                    onSelectedSeatsChange={changeSelectedSeats}
                    eventId={eventId}
                    actionLabel={actionLabel}
                    actionHandler={actionHandler}
                    complimentaryButton={complimentaryButton}
                    isComplimentary={isComplimentary}
                    setIsComplimentary={setIsComplimentary}
                />
            )}
        </>
    )
}
